<template>
  <div class="main-wrap">
    <el-carousel indicator-position="outside">
      <el-carousel-item v-for="(item, index) in detail.more.photos" :key="index">
        <img class="img-banner" :src="item.url" />
      </el-carousel-item>
    </el-carousel>
    <div class="news-detail-wrap">
      <div class="news-detail w1200">
        <div class="news-detail-info">
          <div class="news-time">

          </div>
          <div style="color: #000;" class="news-title">{{ detail.post_title }}</div>
        </div>

        <div class="news-content" v-html="detail.post_content"></div>
        <div class="files" v-if="detail.more && detail.more.files">
          <a v-for="(item, index) in detail.more.files" :key="index" :href="item.url">{{ item.name }}</a>
        </div>
      </div>
    </div>
    <!-- <div id="cates" class="sec-title w1200">酒店周边</div> -->
    <!-- <div class="sec-cates w1200">
      <div
        :class="['sec-cate', selectCate == item.id ? 'sec-cate-active' : '']"
        v-for="(item, index) in navs"
        :key="index"
        @click="changeCate(item.id)"
      >
        {{ item.name }}
      </div>
    </div> -->
    <div class="sec-cates-phone w1200">
      <Dropdown @on-click="changeCate" style="display: block" trigger="click" transfer transfer-class-name="ddds">
        <div class="sec-phone-cate">
          {{ navs[selectCate] && navs[selectCate].name }}
          <img src="../assets/icon_down.png" alt="" srcset="" />
        </div>
        <DropdownMenu slot="list" style="left: 16px; right: 16px; width: auto">
          <DropdownItem v-for="item in navs" :key="item.name" :name="item.id">{{ item.name }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <!-- <div class="sections w1200">
      <Row type="flex" justify="space-between">
        <Col
          :xs="24" :sm="11"  :lg="8"
          v-for="(item, index) in sections"
          :key="index"
        >
          <div class="section-wrap" @click="goNewsDetail(item.id)">
            <div class="section">
              <div class="section-time">
                {{ item.categories && item.categories[0].name }}
              </div>
              <img class="section-img" :src="item.thumbnail" alt />

              <div class="section-title">{{ item.post_title }}</div>
              <div class="section-more">
                了解更多 <img src="../assets/right.png" alt="" srcset="" />
              </div>
            </div>
          </div>
        </Col>
        <Col :xs="24" :sm="11"  :lg="8"> </Col>
        <Col :xs="24" :sm="11"  :lg="8"> </Col>
      </Row>
    </div> -->
    <div class="contact-wrap w1200" @click="goNewsDetail(contact.url)">
      <div class="contact">
        <div class="contact-time">
          {{ contact.title }}
        </div>

        <div class="contact-title">{{ contact.content }}</div>
        <div class="contact-more" v-if="$i18n.locale == 'cn'">
          了解更多 <img src="../assets/img/right-right.png" alt="" srcset="" />
        </div>
        <div class="contact-more" v-if="$i18n.locale == 'en'" style="white-space: nowrap;">
          know more about <img src="../assets/img/right-right.png" alt="" srcset="" />
        </div>
      </div>
      <img class="contact-img" :src="imgUrl + contact.image" alt />
    </div>
  </div>
</template>

<script>
export default {
  name: "detail",
  components: {},
  mounted() { },
  data() {
    return {
      isLoading: false,
      isTotal: false,
      sections: [],
      contact: {},
      selectCate: 0,
      navs: "",
      page: 1,

      detail: {},

    };
  },
  mounted() {
    this.getCates();
    this.getSwiper2();
    this.getNewsDetail(this.$route.query.id);
    this.$EventBus.$on("goNav", (id) => {
      Object.keys(this.navs).map(v => {
        if (this.navs[v].category.id == id) {
          this.changeCate(v)
        }
      })
    });
  },
  created() {
    // this.$router.go(0)
    // console.log(this.$route.query.id,8888888888888888);
  },
  methods: {
    changeCate(id) {
      this.selectCate = id;
      this.getSections(this.navs[this.selectCate].category.id);
    },
    //分类
    getCates() {
      let self = this;
      this.$axios

        .get(`/api/portal/navMenu/menu?lang=${this.$i18n.locale}&nav=middle`)
        .then(function (res) {
          self.navs = res.data.data;
          self.selectCate = parseInt(Object.keys(res.data.data)[0]);
          self.getSections(res.data.data[self.selectCate].category.id);
        });
    },
    //文章
    getSections(id) {
      let self = this;

      this.$axios
        .get(
          `/api/portal/lists/getCategoryPostLists?category_id=${id}&page=${this.page}&listRows=6&lang=${this.$i18n.locale}&relation=categories`
        )
        .then(function (res) {
          console.log(res, 6666666666666666666);
          self.sections = res.data.data.list;
        });
    },
    //跳转文章详情
    goNewsDetail(id) {
      this.$router.push("/detail?id=" + id + `?lang=${this.$i18n.locale}`);
    },
    //文章详情
    getNewsDetail(id) {
      let self = this;
      this.isLoading = true;
      this.$axios.get(`/api/portal/pages/${id}`).then(function (res) {
        console.log(res);
        self.detail = res.data.data;
      });
    },
    //联系我们
    getSwiper2() {
      let self = this;
      this.$axios
        .get(`/api/portal/slide/other?nav=30&lang=${this.$i18n.locale}`)
        .then(function (res) {
          self.contact = res.data.data[0];
        });
    },
  },
  watch: {
    "$i18n.locale"() {
      this.getSections();
      this.getNewsDetail(this.$route.query.id);
    },
    "$route.query.id"() {
      this.getSections();
      this.getNewsDetail(this.$route.query.id);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-carousel--horizontal {
  overflow: hidden;
  width: 1200px;
  margin: 108px auto 0 !important;
  height: 660px;
}

::v-deep .el-carousel__container {
  height: 660px !important;
}

.news-content {
  padding-top: 120px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.img-banner {
  width: 100%;
  // height: 874px!important;
  height: 660px!important;
  // margin: -100px 0;
  // margin-top: -107px;
  width: 100%;
  object-fit: cover;
  margin-left: 50%;
  transform: translateX(-50%);
  vertical-align: middle;
}

.news-detail-info {
  height: 660px;
  margin-top: -670px;
  position: relative;
  z-index: 3;
}

.news-wrap {
  width: 100%;
  height: 300px;
  overflow: hidden;
  position: relative;
  margin-bottom: 36px;

  .news-title {
    font-size: 36px;
    font-weight: 500;
    color: rgba(0, 35, 60, 1);
    line-height: 78px;
    margin-top: 90px;
    left: 50%;
    text-align: left;
    transform: translateX(-50%);
    position: absolute;
    z-index: 9;
  }

  .banner {
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
  }
}

.btn-more {
  margin-bottom: 36px;

}


.news-detail {
  img {
    max-width: 100%;
  }

  .news-detail-info {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .news-title {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: bold;
    color: #ffffff;
    line-height: 33px;
    margin-bottom: 35px;
    text-align: left;
  }

  .news-time {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    margin-bottom: 16px;
    text-align: left;
  }
}

.news-content {
  padding-top: 48px;
  box-sizing: border-box;
  line-height: 30px;
}

.news-content {
  padding-top: 0px !important;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 30px;

}

@media (max-width:1400px) {
  .news-title {
    color: #000 !important;
  }

  .el-carousel--horizontal {
    width: 100% !important;
    height: 660px !important;
    margin: 0 auto;
    overflow: hidden;
    margin: 60px auto 0 !important;
  }
}

@media (max-width:1240px) {
  .news-title {
    color: #000 !important;
  }

  .el-carousel--horizontal {
    width: 100% !important;
    height: 660px !important;
    margin: 0 auto;
    overflow: hidden;
    margin: 60px auto 0 !important;
  }

}

@media (min-width: 1000px) {
  .news-title {
    color: #000 !important;
  }

  .news-detail {
    padding: 0px 200px;
  }
}

.sec-cates {
  overflow: hidden;
  display: block;
}

.sec-cates-phone {
  display: none;
  margin-bottom: 16px;
}

.sec-cate {
  float: left;
  margin-right: 24px;
  margin-bottom: 24px;
  line-height: 56px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #080404;
  width: 180px;
  text-align: center;
  height: 56px;
  background: #fff;
  cursor: pointer;
}

.sec-cate:last-child {
  margin-right: 0px;
}

.sec-cate-active {
  line-height: 56px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #080404;
  width: 180px;
  text-align: center;
  height: 56px;
  background: #f8ba05;
  box-shadow: 0px 5px 8px -2px rgba(227, 169, 0, 0.47);
}

.sec-phone-cate {
  padding: 0px 24px;
  width: 100%;
  box-sizing: border-box;
  line-height: 56px;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
}

.sec-phone-cate img {
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
}

.sec-title {
  padding: 24px 0px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #080404;
  line-height: 33px;
}

.section-wrap {
  overflow: hidden;
  padding: 24px;
  background: #fff;
  margin-bottom: 36px;
}

.section-wrap:hover {
  box-shadow: 0px 7px 24px -2px rgba(8, 4, 4, 0.12);
}

.sections {
  margin-bottom: -36px;
}

.section {
  box-sizing: border-box;
  // max-width: 376px;
  flex: 1 1 300px;

  background: #fff;

  .section-time {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #080404;
    line-height: 22px;
    margin-bottom: 16px;
  }

  .section-title {
    margin: 16px 0px 32px 0px;
    height: 60px;
    display: -webkit-box;
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #080404;
    line-height: 30px;
  }

  .section-img {
    height: 263px;
    max-width: 100%;
    object-fit: contain;
  }

  .section-des {
    font-size: 16px;
    height: 48px;
    width: 100%;
    box-sizing: border-box;
    padding: 0px 16px;
    font-weight: 400;
    color: rgba(0, 35, 60, 0.48);
    line-height: 24px;
    margin-bottom: 4px;
    text-shadow: 0px 16px 32px rgba(0, 43, 85, 0.04);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

.section-wrap:hover .section-more {
  background: rgb(128, 38, 40);
  color: #fff;
}

.section-more {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 156px;
  padding: 12px;
  height: 48px;
  background: #fff;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 21px;
  cursor: pointer;
}

.section-more img {
  width: 22px;
  height: 22px;
}

.ivu-select-dropdown {
  left: 16px;
  right: 16px;
  width: auto;
}

.contact-wrap {
  margin: 30px auto 72px;
  display: flex;
  height: 400px;
  position: relative;

  .contact {
    padding: 64px 24px 87px 48px;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #f3eeee;
    position: relative;
    z-index: 3;

    .contact-time {
      margin-bottom: 24px;

      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #080404;
      line-height: 25px;
    }

    .contact-title {
      margin-bottom: auto;

      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #080404;
      line-height: 45px;
    }

    .contact-more {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      align-self: baseline;
      min-width: 110px;
      padding: 12px;
      height: 48px;
      background: rgb(128, 38, 40);
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 21px;
      cursor: pointer;

      img {
        width: 22px;
        height: 22px;
        flex: 0 0 22px;
      }
    }
  }

  img {
    width: 48%;
    object-fit: cover;
    height: 100%;
  }
}

@media (max-width: 768px) {
  ::v-deep .el-carousel__indicators--outside {
    margin-top: 0px !important;
    // display: none!important;
    margin-top: 0px !important;
    position: absolute;
    top: 330px;
    left: 50%;
    transform: translateX(-50%);
  }

  .news-title {
    color: #fff !important;
  }

  .el-carousel--horizontal {
    overflow: hidden;
    width: 100%;
    height: 360px;
    margin: 60px auto 0 !important;
  }

  ::v-deep .el-carousel__container {
    height: 360px !important;
  }

  .news-content {
    padding-top: 120px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .img-banner {
    width: 100%;
    margin-top: -30px !important;
    height: 360px !important;
    -o-object-fit: cover;
    object-fit: cover;
    vertical-align: middle;
  }

  .news-detail-info {
    height: 360px !important;
    margin-top: -670px !important;
    position: relative;
    z-index: 3;
  }

  .news-content {
    padding-top: 0px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;

  }

  ::v-deep .news-content p span {
    font-size: 16px !important;
  }

  .main-wrap {
    margin-top: 0px;
  }

  .contact-wrap {
    height: 248px;

    ::v-deep .contact-img {
      width: 122px !important;
      position: absolute;
      top: 26px !important;
      z-index: 99;
      height: 110px !important;
      right: 16px !important;
      display: none;

    }

    .contact {

      padding: 40px 50px 24px;
      background: #f3eeee;

      ::v-deep .contact-img {
        width: 122px !important;
        position: absolute;
        top: 26px !important;
        z-index: 99;
        height: 110px !important;
        right: 16px !important;
        display: none !important;
      }

      .contact-time {
        margin-bottom: 24px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #080404;
        line-height: 20px;
      }

      .contact-title {
        margin-bottom: auto;
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #080404;
        line-height: 24px;
      }
    }

  }

  .sec-cates {
    display: none;
  }

  .sec-title {
    padding-left: 16px;
  }

  .section-wrap:hover .section-more {
    background: #fff;
  }

  .sec-cates-phone {
    display: none;
  }
}

.files {
  padding: 16px;
  line-height: 32px;

  a {
    display: block;
    text-decoration: underline;
  }
}

.img-banner {
  width: 100%;
  height: 500px;
  object-fit: cover;
  margin-left: 50%;
  transform: translateX(-50%);
  vertical-align: middle;
}

.news-detail-info {
  height: 660px;
  margin-top: -670px;
  position: relative;
  z-index: 3;
}

@media (max-width: 768px) {
  .img-banner {
    width: 100%;
    height: 400px;
    object-fit: cover;
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .main-wrap {
    margin-top: 0px;
  }

  .news-detail-info {
    height: 538px;
    margin-top: -670px;
  }
}

.news-detail-info {
  height: 500px;
  margin-top: -410px;
  position: relative;
  z-index: 3;
}</style>